import { FC } from 'react'
import { ContentContainer } from '@/root/components/shared'
import { LowerFooterItem, UpperFooterItem } from '@/root/shared-types'
import LinksAndInfoItem from '../LinksAndInfoItem/LinksAndInfoItem'

interface FooterLinksAndInfoProps {
  upperFooterItems: UpperFooterItem[]
  lowerFooterItems: LowerFooterItem[]
}

const FooterLinksAndInfo: FC<FooterLinksAndInfoProps> = ({ upperFooterItems, lowerFooterItems }) => {
  return (
    <div className="bg-primary-base relative overflow-hidden">
      <ContentContainer>
        <div className="flex flex-col gap-8 px-5 py-9">
          <div className="xs:grid-cols-2 grid gap-7 md:grid-cols-4">
            {upperFooterItems.map(({ id, title, content }, index) => (
              // oxlint-disable-next-line react/no-array-index-key
              <LinksAndInfoItem key={id || title || `upper-${index}`} title={title} items={content} useOldBoraOrigin />
            ))}
          </div>

          <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {lowerFooterItems.map(({ id, icon, content }, index) => (
              // oxlint-disable-next-line react/no-array-index-key
              <div className="xs:max-w-sm sm:max-w-72" key={id || `lower-${index}`}>
                <LinksAndInfoItem icon={icon} items={content} />
              </div>
            ))}
          </div>
        </div>
      </ContentContainer>

      <div className="border-secondary absolute right-[-400px] bottom-[-400px] size-[800px] rounded-full border" />
      <div className="border-secondary absolute right-[-250px] bottom-[-250px] size-[500px] rounded-full border" />
    </div>
  )
}

export default FooterLinksAndInfo
